import React, { useState } from "react";
import { Button } from "./Elements";
import { useSelector } from "react-redux";
import NiceModal from "@ebay/nice-modal-react";
import { getAgentAnswer } from "services/liveevents";

export const Incoming = ({
  display,
  questions = [],
  socketRef,
  liveEvent,
  setQuestions,
  height,
}) => {
  const { activeUser, token } = useSelector((state) => state.users);

  const Question = ({ liveEvent, question, index, socketRef }) => {
    const [error, setError] = useState("");
    const [agentAnswering, setAgentAnswering] = useState(false);
    const event_id = liveEvent?.public_id ?? liveEvent?.id;
    return (
      <li
        key={index}
        style={{
          fontSize: "16px",
          marginBottom: "10px",
          width: "100%",
          border: "1px solid #d0d0d0",
          borderRadius: "10px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          padding: "5px 10px",
          flexDirection: "column",
        }}
      >
        <div>{question?.message}</div>
        <div
          style={{
            fontSize: "14px",
            color: "#808080",
            fontStyle: "italic",
          }}
        >
          From: {question?.user?.nickname}
        </div>
        <div
          style={{
            fontSize: "14px",
            color: "#808080",
            fontStyle: "italic",
          }}
        >
          Relevance: {question?.relevance} ({question?.relevance_reason})
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "5px",
            fontSize: "14px",
            justifyContent: "space-around",
            width: "100%",
            flexWrap: "wrap",
          }}
        >
          <Button
            bgcolor="#f3f4f6"
            textcolor="#334155"
            onClick={() => {
              console.log("!!! DISMISSING QUESTION: ", question);
              socketRef.current.emit("update-message-status", {
                event_id: event_id,
                broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                message_id: question.public_id,
                status: "dismissed",
                token: token,
              });
              setQuestions((prevQuestions) =>
                prevQuestions.filter((q) => q.public_id !== question.public_id)
              );
            }}
          >
            <i className="fas fa-times"></i>
            Dismiss
          </Button>
          <Button
            bgcolor="#f3f4f6"
            textcolor="#334155"
            onClick={(e) => {
              setError(null);
              console.log("!!! REPLYING TO QUESTION: ", question);
              NiceModal.show("answer-modal", {
                event_id: event_id,
                question: question,
                position: {
                  top: window.innerHeight / 2 - 150,
                  left: window.innerWidth / 2 - 200,
                },
              }).then((data) => {
                console.log("!!! QUESTION: ", question);
                const { response, source } = data;
                console.log("!!! ANSWER SUBMITTED: ", response);
                question.response = response;
                question.responded_at = new Date().toISOString();
                if (source !== "agent") {
                  question.response_by = `${activeUser?.firstname} ${activeUser?.lastname}`; // Replace with actual user ID if needed
                } else {
                  question.response_by = "agent";
                }
                question.response_source = source;
                question.status = "answered";
                setQuestions((prevQuestions) =>
                  prevQuestions.map((q) =>
                    q.public_id === question.public_id
                      ? {
                          ...q,
                          status: "answered",
                          response: response,
                          response_source: source,
                          responded_at: new Date().toISOString(),
                          response_by: {
                            firstname:
                              source === "agent"
                                ? "agent"
                                : activeUser?.firstname,
                            lastname:
                              source === "agent" ? "" : activeUser?.lastname,
                            email: source === "agent" ? "" : activeUser?.email,
                          },
                        }
                      : q
                  )
                );

                socketRef.current.emit("update-message-response", {
                  event_id: event_id,
                  broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                  message_id: question.public_id,
                  status: "answered",
                  response: response,
                  response_by: activeUser?.public_id, // Replace with actual user ID if needed
                  response_source: source,
                  token: token,
                });
              });
            }}
          >
            <i className="fas fa-reply"></i>
            Answer
          </Button>
          <Button
            onClick={async () => {
              setError(null);
              setAgentAnswering(true);
              const response = await getAgentAnswer(
                event_id,
                question?.message
              );

              if (!response.success) {
                setError(response.message);
                return;
              }

              const answer = response.answer;
              if (answer?.agent_message?.message) {
                question.answer = answer.agent_message.message;
                console.log("!!! AGENT ANSWER: ", question.answer);
                question.response = question.answer;
                question.responded_at = new Date().toISOString();
                question.response_by = "agent";
                question.response_source = "agent";
                question.status = "answered";
                setQuestions((prevQuestions) =>
                  prevQuestions.map((q) =>
                    q.public_id === question.public_id
                      ? {
                          ...q,
                          status: "answered",
                          response: question.answer,
                          response_source: "agent",
                          responded_at: new Date().toISOString(),
                          response_by: {
                            firstname: "agent",
                            lastname: "",
                            email: "",
                          },
                        }
                      : q
                  )
                );

                console.log("Calling update message response");
                socketRef.current.emit("update-message-response", {
                  event_id: event_id,
                  broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                  message_id: question.public_id,
                  status: "answered",
                  response: question.answer,
                  response_by: "agent", // Replace with actual user ID if needed
                  response_source: "agent",
                  token: token,
                });
              } else {
                setError(
                  "No answer provided by the agent. Please try again later."
                );
              }
              setAgentAnswering(false);
            }}
          >
            <i className="fas fa-robot"></i>
            {agentAnswering ? "Thinking..." : "Agent Answer"}
          </Button>
          <Button
            bgcolor="#dcfce8"
            textcolor="#16a34a"
            onClick={() => {
              console.log("!!! APPROVING QUESTION: ", question);
              socketRef.current.emit("update-message-status", {
                event_id: event_id,
                broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                message_id: question.public_id,
                status: "approved",
                token: token,
              });
              setQuestions((prevQuestions) =>
                prevQuestions.map((q) =>
                  q.public_id === question.public_id
                    ? { ...q, status: "approved" }
                    : q
                )
              );
            }}
          >
            <i className="fas fa-check-circle"></i>
            Approve
          </Button>
        </div>
        {error && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <p style={{ color: "red" }}>{error}</p>
          </div>
        )}
      </li>
    );
  };

  return (
    <div
      style={{
        display: display ? "block" : "none",
        paddingTop: "20px",
        paddingLeft: "20px",
        height: height,
        overflow: "auto",
      }}
    >
      <ul>
        {questions.length > 0 ? (
          questions
            .filter((q) => !q.inappropriate && q.status === "pending")
            .sort((a, b) => b.relevance - a.relevance)
            .map((question, index) => (
              <Question
                key={index}
                liveEvent={liveEvent}
                question={question}
                index={index}
                socketRef={socketRef}
              />
            ))
        ) : (
          <li>No questions available.</li>
        )}
      </ul>
    </div>
  );
};

export default Incoming;
